/**
 * Directive: capitalize
 */
angular.module('acme.common.directive.capitalize', [])
.directive('capitalize', ['$parse', function($parse) {

    return {
      restrict: 'A',
      require: 'ngModel',
      
      link: function($scope, $element, $attrs, modelCtrl) {

        var capitalize = function(inputValue) {
          if ( (inputValue === undefined) || (inputValue == null) ) { inputValue = ''; }
          var capitalized = inputValue.toUpperCase();
          if(capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        };

        modelCtrl.$parsers.push(capitalize);

        // capitalize initial value
        capitalize(($parse($attrs.ngModel))($scope));
      }

    };

}]);